import styled from '@emotion/styled';
import LongText from '__components/Inputs/LongText';

export const StyledLongText = styled(LongText)`
  height: 300px;
`;
